import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5335ef6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-detail-page" }
const _hoisted_2 = { class: "campaign-detail-page__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "ステップ配信", -1))
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-new-campaign" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn-primary" }, "新規作成")
], -1))
const _hoisted_6 = { class: "data-table" }
const _hoisted_7 = {
  key: 0,
  class: "flex align-items-start"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-cancel-deliveryAmount-svg" }, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex align-items-center" }

import LineChart from "../components/LineChart.vue";
import { ref } from "vue";
import { PLACEHOLDER_SELECT } from "@/clinic/typings/constants/clinic";


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentWorkflow',
  setup(__props) {

const selectedCity = ref();
const options = ref([
  { name: "Opt 1", icon: "pi pi-circle-fill text-red" },
  { name: "Opt 2", icon: "pi pi-stop-circle text-gray" },
  { name: "Opt 3", icon: "pi pi-times-circle text-green" },
]);
const cities = ref([
  { name: "New York", code: "NY" },
  { name: "Rome", code: "RM" },
  { name: "London", code: "LDN" },
  { name: "Istanbul", code: "IST" },
  { name: "Paris", code: "PRS" },
]);

const products = ref([
  {
    id: "Opt 1",
    deliveryName: "予約促進A",
    deliveryAmount: 100,
    openAmount: "50/50%",
    clickAmount: "30/30%",
    completedBookingAmount: "10/10%",
    actualVisitAmount: "5/5%",
  },
  {
    id: "Opt 1",
    deliveryName: "予約促進B",
    deliveryAmount: 100,
    openAmount: "50/50%",
    clickAmount: "30/30%",
    completedBookingAmount: "10/10%",
    actualVisitAmount: "5/5%",
  },
  {
    id: "Opt 1",
    deliveryName: "予約促進C",
    deliveryAmount: 100,
    openAmount: "50/50%",
    clickAmount: "30/30%",
    completedBookingAmount: "10/10%",
    actualVisitAmount: "5/5%",
  },
  {
    id: "Opt 1",
    deliveryName: "予約促進D",
    deliveryAmount: 100,
    openAmount: "50/50%",
    clickAmount: "30/30%",
    completedBookingAmount: "10/10%",
    actualVisitAmount: "5/5%",
  },
  {
    id: "Opt 1",
    deliveryName: "予約促進E",
    deliveryAmount: 100,
    openAmount: "50/50%",
    clickAmount: "30/30%",
    completedBookingAmount: "10/10%",
    actualVisitAmount: "5/5%",
  },
]);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleClickStatusSegmentOptions = (dataStatus: any, options: any) => {
  dataStatus.data.id = options.value.name;
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Dropdown, {
          modelValue: selectedCity.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCity).value = $event)),
          options: cities.value,
          optionLabel: "name",
          placeholder: "店舗名",
          class: "w-full md:w-20rem"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createVNode(LineChart),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_DataTable, {
        value: products.value,
        scrollable: "",
        scrollHeight: "500px",
        showGridlines: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ステータス"
          }, {
            body: _withCtx((dataStatus) => [
              _createVNode(_component_Dropdown, {
                modelValue: dataStatus.data.id,
                "onUpdate:modelValue": ($event: any) => ((dataStatus.data.id) = $event),
                options: options.value,
                optionLabel: "name",
                placeholder: _unref(PLACEHOLDER_SELECT),
                class: "w-full",
                onChange: ($event: any) => (handleClickStatusSegmentOptions(dataStatus, $event))
              }, {
                value: _withCtx((slotProps2) => [
                  (slotProps2.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", null, _toDisplayString(slotProps2.value), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(slotProps2.placeholder), 1))
                ]),
                option: _withCtx((slotProps2) => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`${slotProps2.option.icon} pr-1`)
                    }, null, 2),
                    _createElementVNode("div", null, _toDisplayString(slotProps2.option.name), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "deliveryName",
            header: "配信名"
          }),
          _createVNode(_component_Column, {
            field: "deliveryAmount",
            header: "配信数"
          }),
          _createVNode(_component_Column, {
            field: "openAmount",
            header: "開封数/率"
          }),
          _createVNode(_component_Column, {
            field: "clickAmount",
            header: "クリック数/率"
          }),
          _createVNode(_component_Column, {
            field: "completedBookingAmount",
            header: "予約完了数/率"
          }),
          _createVNode(_component_Column, {
            field: "actualVisitAmount",
            header: "実来店数/率"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
}
}

})